var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[(_vm.isAuthCheckRequested && _vm.isAutoAuthing)?_c('div',{staticClass:"auto-login-loader"},[_c('v-progress-circular',{attrs:{"size":70,"color":"#055289","indeterminate":""}})],1):_vm._e(),_c('Layout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }